<div class="container">
	<div class="row justify-content-center mt-5">
		<div class="col-md-6">
			<div class="signup-form">
				<div class="text-center mb-4">
					<h3 class="font-weight-bold text-primary">Welcome to<span style="color: blue;"> KIKCAD 2D</span>
					</h3>
					<p class="text-muted font-weight-bold">
						Embrace the creative possibilities as you dive into design estimation. Your journey is unique.
						Explore freely and enjoy the process of bringing your designs to life. Happy creating!
					</p>
				</div>

				<form class="form" [formGroup]="registerForm" autocomplete="off" novalidate="novalidate"
					id="kt_login_form">
					<div style="width: 256px; align-items: center; margin: 0 auto; text-align: center;">
						<div class="form-group">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text"><i class="material-icons">person</i></span>
								</div>
								<input type="text" id="fullname" class="form-control" placeholder="Fullname"
									formControlName="fullname" />
							</div>
							<mat-error *ngIf="isControlHasError('fullname', 'required')">
								<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('fullname', 'minlength')">
								<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('fullname', 'maxlength')">
								<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
							</mat-error>
						</div>

						<div class="form-group">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text"><i class="material-icons">email</i></span>
								</div>
								<input type="email" id="email" class="form-control"
									placeholder="{{ 'AUTH.INPUT.EMAIL' | translate }}" formControlName="email"
									autocomplete="off" />
							</div>
							<mat-error *ngIf="isControlHasError('email', 'required')">
								<strong>{{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('email', 'email')">
								<strong>{{ "AUTH.VALIDATION.INVALID_FIELD" | translate }}</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('email', 'minlength')">
								<strong>{{ "AUTH.VALIDATION.MIN_LENGTH_FIELD" | translate }} 3</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('email', 'maxlength')">
								<strong>{{ "AUTH.VALIDATION.MAX_LENGTH_FIELD" | translate }} 320</strong>
							</mat-error>
						</div>
						<div class="form-group">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text"><i class="material-icons">person</i></span>
								</div>
								<input type="text" id="username" class="form-control" placeholder="Username"
									formControlName="username" />
							</div>
							<mat-error *ngIf="isControlHasError('username', 'required')">
								<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('username', 'minlength')">
								<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('username', 'maxlength')">
								<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
							</mat-error>
						</div>
						<div class="form-group">
							<mat-form-field id="selectcountry" class="mat-form-field-fluid" appearance="outline">
								<mat-select placeholder="country" formControlName="country">
									<mat-option value="">Choose country</mat-option>
									<mat-option *ngFor="let country of countries" [value]="country.value">
										<span class="fi fi-{{ country.code | lowercase }}"></span> {{ country.name }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div class="form-group">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text"><i class="material-icons">lock</i></span>
								</div>
								<input type="password" id="password" class="form-control"
									placeholder="{{ 'AUTH.INPUT.PASSWORD' | translate }}" formControlName="password"
									autocomplete="off" />
							</div>
							<mat-error *ngIf="isControlHasError('password', 'required')">
								<strong>{{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('password', 'minlength')">
								<strong>{{ "AUTH.VALIDATION.MIN_LENGTH_FIELD" | translate }} 3</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('password', 'maxlength')">
								<strong>{{ "AUTH.VALIDATION.MAX_LENGTH_FIELD" | translate }} 100</strong>
							</mat-error>
						</div>
						<div class="form-group">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text"><i class="material-icons">lock</i></span>
								</div>
								<input type="password" id="confirmPassword" class="form-control"
									placeholder="{{ 'AUTH.INPUT.CONFIRM_PASSWORD' | translate }}"
									formControlName="confirmPassword" autocomplete="off" />
							</div>
							<mat-error *ngIf="isControlHasError('confirmPassword', 'required')">
								<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('confirmPassword', 'minlength')">
								<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
							</mat-error>
							<mat-error *ngIf="isControlHasError('confirmPassword', 'maxlength')">
								<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
							</mat-error>
							<mat-error
								*ngIf="registerForm.get('confirmPassword').errors && registerForm.get('confirmPassword').errors.ConfirmPassword">
								<strong>Password and Confirm Password didn't match.</strong>
							</mat-error>
						</div>
						<div class="form-group" *ngIf="registerForm.get('employedByDistributionCompany').value">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text"><i class="material-icons">business</i></span>
								</div>
								<input type="text" id="distributorCompanyName" class="form-control"
									placeholder="Distributor Company Name" formControlName="distributorCompanyName" />
							</div>
						</div>
						<div class="form-group flex" *ngIf="!registerForm.get('directlyBuyFromKIKBLOX').value">
							<mat-checkbox formControlName="employedByDistributionCompany">I was referred by a
								KIKBLOX-authorised distributor</mat-checkbox>
						</div>
						<div class="form-group flex" *ngIf="!registerForm.get('employedByDistributionCompany').value">
							<mat-checkbox formControlName="directlyBuyFromKIKBLOX">
								I directly buy from KIKBLOX
							</mat-checkbox>
						</div>
						<div class="form-group flex">
							<mat-checkbox name="agree" formControlName="agree">
								I agree to the <a routerLink="/terms-conditions">terms & conditions</a>
							</mat-checkbox>
						</div>

						<div class="form-group d-flex justify-content-between align-items-center mt-4">
							<button id="kt_login_signin_submit" (click)="submit()" [ngClass]="{
				  'spinner spinner-right spinner-md spinner-light': loading
				}" class="btn btn-primary font-weight-bold px-4 py-2">{{ 'AUTH.GENERAL.SUBMIT_BUTTON' | translate }}</button>
							<a href="/auth/login" id="kt_login_signup_cancel"
								class="btn btn-primary font-weight-bold px-4 py-2">Cancel</a>
						</div>
					</div>
					<p>
						<a href="https://kikblox.com" target="_blank">Kikblox</a> |
						<a href="https://lk.linkedin.com/company/kikblox" target="_blank">LinkedIn</a> |
						<a href="https://www.youtube.com/@kikblox" target="_blank">YouTube</a>
					</p>

					<div class="text-muted font-weight-bold mt-4">
						<p style="font-size: 8.5px;">
							By accessing this KIKCAD 2D software, you acknowledge that its usage is at your own
							discretion. KIK (Pvt) LTD disclaims any liability for errors, losses, or damages resulting
							from its use.
						</p>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>